<script setup lang="ts">
import iconPicture from '~/assets/images/logo.png'
import AppBrandEnvBadges from '~/components/app/layout/AppBrandEnvBadges.vue'
</script>

<template>
  <div class="app-layout app-layout--error-shell">
    <header>
      <NuxtLink class="website-name" to="/">
        <img :src="iconPicture" alt="mon-orga-icon" width="40" height="40" decoding="async">
        <p class="website-name__title h3">MonOrga</p>
        <AppBrandEnvBadges />
      </NuxtLink>
    </header>
    <main class="main-content main-content--error-shell">
      <slot />
    </main>
  </div>
</template>

<style scoped lang="scss">
@use '~/assets/scss/partials/elpdl/spacing' as *;

/* Autonome : error.vue ne charge pas le layout default - mêmes tokens que default.vue (header + zone page). */
.app-layout--error-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.app-layout--error-shell > header {
  position: relative;
  z-index: 100;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 $spacing-2xl;
  background: var(--color-bg-header);
  border: none;
  border-bottom: 1px solid var(--color-border);
  height: 72px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.app-layout--error-shell > header .website-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: $spacing-m;
  text-decoration: none;
}

.app-layout--error-shell > header .website-name img {
  width: 40px;
  height: 40px;
}

.app-layout--error-shell > header .website-name h3,
.app-layout--error-shell > header .website-name .website-name__title {
  margin: 0;
  color: var(--color-primary);
}

.app-layout--error-shell > header .website-name :deep(.website-name__beta),
.app-layout--error-shell > header .website-name :deep(.website-name__recette) {
  margin: 0;
  color: var(--color-beta-badge);
}

.app-layout--error-shell > main.main-content {
  background-color: var(--color-bg-page);
  flex: 1;
  min-height: 0;
  padding: $spacing-xl $spacing-xl $spacing-l;
  max-width: 100%;
  box-sizing: border-box;
}

.main-content--error-shell {
  display: flex;
  flex-direction: column;
}
</style>
